// extracted by mini-css-extract-plugin
export default {"tupacGrid":"rn-z","tupacHeader":"sn-z","tupacHeader2":"tn-z","tupacMenu":"un-z","tupacMenu2":"vn-z","tupacMain":"wn-z","tupacMain2":"xn-z"};